/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../Tables/ResizableTable/components/ResizableReactTable';

const ViewSalesReportModal = ({ isOpen, handleModal, modalData, tableHeaderData, fileName, title }) => {
    const exportToExcel = () => {
        if (!modalData || !modalData.length) {
            console.log('No data to export');
            return;
        }

        const headers = tableHeaderData?.map(col => col.Header) || [];

        // Prepare data for export using tableHeaderData structure
        const worksheetData = modalData.map(row => {
            const exportRow = {};
            tableHeaderData.forEach(col => {
                exportRow[col.Header] = row[col.accessor] || '';
            });
            return exportRow;
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(worksheetData, { header: headers });

        // Set column widths for better formatting
        const columnWidths = tableHeaderData.map((col) => {
            // Set different widths based on content type
            if (col.accessor && col.accessor.toLowerCase().includes('description')) return { wch: 30 };
            if (col.accessor && col.accessor.toLowerCase().includes('name')) return { wch: 25 };
            if (col.accessor && col.accessor.toLowerCase().includes('id')) return { wch: 20 };
            if (col.accessor && col.accessor.toLowerCase().includes('amount')) return { wch: 15 };
            if (col.accessor && col.accessor.toLowerCase().includes('date')) return { wch: 18 };
            return { wch: 15 };
        });
        worksheet['!cols'] = columnWidths;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "report");

        // Generate filename - use provided fileName or default to "report"
        const excelFileName = fileName ? `${fileName}.xlsx` : "report.xlsx";

        // Save file
        XLSX.writeFile(workbook, excelFileName);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => handleModal(true)}
            style={{ maxWidth: '800px' }}
            className="modal-dialog ltr-support"
            centered
        >
            <div className="modal__header">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={() => handleModal(false)}
                />
                <h4 className="text-modal  modal__title">{title || "Report"}</h4>
                <div className="ExcelTable">
                    <div
                        className="option table-action btn btn-sm"
                        onClick={exportToExcel}
                        style={{
                            cursor: !modalData?.length ? 'not-allowed' : 'pointer',
                            opacity: !modalData?.length ? 0.6 : 1
                        }}
                    >
                        <h4 className="action-title">Download</h4>
                    </div>
                </div>
            </div>
            <div className="modal__body">
                <Row>
                    <ResizableDataTable reactTableData={{ tableHeaderData }} data={modalData} />
                </Row>
            </div>
        </Modal>
    )
}

ViewSalesReportModal.propTypes = {
    handleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    modalData: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,
    fileName: PropTypes.string,
    title: PropTypes.string,
};

ViewSalesReportModal.defaultProps = {
    fileName: "",
    title: ""
}


export default ViewSalesReportModal;